/* eslint-disable */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import config from './config'

const oktaAuth = new OktaAuth(config.oidc)
export function useAuthService() {
  const history = useNavigate() // example from react-router

  const triggerLogin = async () => {
    await oktaAuth.signInWithRedirect()
  }
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
    history(
      toRelativeUrl(
        originalUri.replace('/support-admin', '') || '/',
        window.location.origin
      ),
      { replace: true }
    )
  }

  const customAuthHandler = async () => {
    const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState()
    if (!previousAuthState || !previousAuthState.isAuthenticated) {
      // App initialization stage
      await triggerLogin()
    } else {
      // Ask the user to trigger the login process during token autoRenew process
      //setAuthRequiredModalOpen(true);
    }
  }
  return { oktaAuth, customAuthHandler, restoreOriginalUri }
}

export default useAuthService
